module.exports = __webpack_public_path__ + "assets/visa-w.7dab27ce.png";